export const SpaceLabelsModel = Symbol.for('SpaceLabelsModel');
